import { useState, useEffect } from 'react';
import { userGetLocalInfo } from './info';

export function useUserPermissions() {
  const [permissions, setPermissions] = useState<any>(null);

  useEffect(() => {
    userGetLocalInfo().then((info) => {
      if (info && info.permission) {
        setPermissions(info.permission);
      }
    });
  }, []);

  return permissions;
}
